import { createAsyncThunk, createSlice, current } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { RootState } from "features/config/store";
import { CommentDataModel } from "features/stock-ordering/core/domain/comment-data.model";
import {
  GetOrderCommentRepository,
  GetOrderCommentResponse,
} from "features/stock-ordering/data/stock-ordering.repository";

export enum GetOrderCommentState {
  initial,
  inProgress,
  success,
  fail,
}

interface InitialState {
  status: GetOrderCommentState;
  message: string;
  data: CommentDataModel | undefined;
}

const initialState: InitialState = {
  status: GetOrderCommentState.initial,
  message: "",
  data: undefined,
};

export const getOrderComment = createAsyncThunk(
  "getOrderComment",
  async (param: string, { rejectWithValue }) => {
    try {
      const response: GetOrderCommentResponse = await GetOrderCommentRepository(
        param
      );
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        if (!error.response) {
          throw error;
        }
        throw rejectWithValue(error.response.data.message);
      }
    }
  }
);

/* Main Slice */
export const getOrderCommentSlice = createSlice({
  name: "getOrderComment",
  initialState,
  reducers: {
    resetGetOrderComment: (state) => {
      state.status = GetOrderCommentState.initial;
      state.data = undefined;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getOrderComment.pending, (state) => {
        state.status = GetOrderCommentState.inProgress;
      })
      .addCase(getOrderComment.fulfilled, (state, action) => {
        if (action.payload) {
          const { message, data } = action.payload;
          state.status = GetOrderCommentState.success;
          state.message = message;
          state.data = data;
        }
      })
      .addCase(getOrderComment.rejected, (state, action) => {
        state.status = GetOrderCommentState.fail;
        state.message = action.payload as string;
        state.data = undefined;
      });
  },
});

export const selectGetOrderComment = (state: RootState) =>
  state.getOrderComment;

export const { resetGetOrderComment } = getOrderCommentSlice.actions;
export default getOrderCommentSlice.reducer;
